// game events
export const GEV = {
    // system
    RESIZE: "system:resize",
    VISIBILITY_CHANGE: "system:visibility:change",
    KEYBOARD_EVENT: "system:keyboard:event",

    // UI
    UI_RENDER_ELSE: "ui:render:else",

    // game states
    GAME_PREPARED: "game:prepared",
    GAME_START: "game:start",
    GAME_PAUSE: "game:pause",
    GAME_RESUME: "game:resume",
    GAME_OVER: "game:over",
    GAME_RESTART: "game:restart",
    GAME_RESET: "game:reset",

    // player interaction
    PLAYER_SCORE: "player:score",

    // main menu
    MAIN_MENU_SHOW: "main:menu:show",
    MAIN_MENU_HIDE: "main:menu:hide",
};
